/* eslint-disable */
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FoorcallCredit = () => {
  const solde =
    useSelector((state) => state.AccountReducer?.foorcallBalance?.solde) || 0;
  const { t } = useTranslation();
  const store = useSelector((state) => state.StoreReducer);

  if (!store?.foorCallRequestId) {
    return null;
  }

  return (
    <div className="w-full">
      <Link
        to="/foorcall"
        aria-label={t("ui.foorcallBalance")}
        className="group flex items-center gap-1.5 w-fit max-w-[140px] px-3 py-1.5 rounded-full
               bg-gradient-to-r from-[#9b59bf]/10 to-[#5a2b73]/10
               dark:from-[#3c3a3d] dark:to-[#2a2830]
               border border-[#9b59bf]/30 dark:border-[#5a5560]
               hover:shadow-[0_0_12px_rgba(155,89,191,0.35)]
               hover:border-[#9b59bf] transition-all duration-300"
       >
        <span
          className="flex items-center justify-center w-5 h-5 rounded-full
                 bg-gradient-to-br from-[#9b59bf] to-[#5a2b73] flex-shrink-0
                 group-hover:scale-110 transition-transform duration-300"
        >
          <svg
            width="11"
            height="11"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 1.33334C4.31811 1.33334 1.33334 4.31811 1.33334 8.00001C1.33334 11.6819 4.31811 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00001C14.6667 4.31811 11.6819 1.33334 8 1.33334ZM8.66668 11.3333H7.33334V10H8.66668V11.3333ZM8.66668 8.66668H7.33334V4.66668H8.66668V8.66668Z"
              fill="white"
            />
          </svg>
        </span>

        <span className="flex items-baseline gap-1 truncate">
          <span className="text-[12px] font-extrabold text-[#9b59bf] dark:text-[#c78ce8]">
            {solde}
          </span>
          <span className="text-[9px] font-medium text-[#9b59bf]/70 dark:text-[#c78ce8]/70 truncate">
            {t("currency")} {t("services.foorCall.confirmationBalance")}
          </span>
        </span>
      </Link>
    </div>
  );
};

export default FoorcallCredit;
